import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(public translate: TranslateService) {
        translate.addLangs(['en', 'he']);
        const languageKey = localStorage.getItem('language');

        if (languageKey) {
            translate.setDefaultLang(languageKey);
        } else {
            translate.setDefaultLang('en');
        }
    }
    ngOnInit(): void {}
}
